import compositionFeatureReducer from './reducers';

export { default as compositionFeatureTypes } from './types';
export { default as compositionFeatureActions } from './actions';
export { default as compositionFeatureSagas } from './sagas';

export default compositionFeatureReducer;
